import React, {Component} from 'react'
import * as colors from '../colors'
import {style, hover} from 'glamor'
import {TimelineMax, TweenMax} from 'gsap'
import Label from './Label'
import {Link} from 'react-router'
import {findDOMNode} from 'react-dom'

export default class RevealThumb extends Component {

  shouldComponentUpdate(){
    return false
  }

  componentDidMount(){
    const image = this.props.image || '/images/category/luxe-mode.jpg'
    setTimeout(()=>{
      findDOMNode(this).style.backgroundImage = `url(${image})`
    }, 0)
  }

  render(){
    const {
        children,
        image='/images/category/luxe-mode.jpg',
        to='/project',
        title='Luxe | Mode',
        ...props
    } = this.props
    return (
      <Link
        {...props}
        to={to}
        {...style({
          display: 'block',
          position: 'relative',
          width: '100%',
          height: '100%',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundColor: colors.moonGray,
          transition: 'filter 0.3s ease-out',
          filter: 'grayscale(0%) contrast(100%)',
          WebkitFilter: 'grayscale(0%) contrast(100%)'
          // backgroundImage: `url(${image})`
        })}
        {...hover({
          filter: 'grayscale(100%) contrast(120%)',
          WebkitFilter: 'grayscale(100%) contrast(120%)'
          // transform: 'scale(0.9)',

        })}
      >
        <div
          {...style({
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom :0,
            zIndex: 1,
            background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.4) 100%)'
          })}
        />


          <div
            {...style({
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              textAlign: 'center',
              padding: '1.5rem',
              zIndex: 2
            })}
          >
              <Label
                {...style({

                })}
              >
                {title}
              </Label>
          </div>
      </Link>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ThumbRevealFit.js
 **/